import React, { useMemo, useState } from "react";
import "./CustomerInformation.scss";
import DynaDatePicker from "../../../../A13/DynaView/DynaDatePicker";
import DynaSelectBox from "../../../../A13/DynaView/DynaSelectBox";
import DynaInput from "../../../../A13/DynaView/DynaInput";
import provincesData from "../../../../../Assets/data/provinces.json";
import citiesData from "../../../../../Assets/data/cities.json";

const CustomerInformation = ({
  sendData,
  setSendData,
  moshtariOptions = [],
  isEditMode,
}) => {
  // ==================== آپشن‌های وضعیت ====================
  const statusOptions = [
    { value: "7", label: "ثبت" },
    { value: "8", label: "تایید" },
    { value: "9", label: "تکمیل" },
    { value: "38", label: "آماده سازی" },
    { value: "39", label: "بارگیری" },
    { value: "40", label: "تحویل" },
  ];

  const provinceOptions = useMemo(() => {
    return provincesData.map((p) => ({
      value: p.name,
      label: p.name,
      id: p.id,
    }));
  }, []);

  const [selectedProvinceId, setSelectedProvinceId] = useState(null);

  const cityOptions = useMemo(() => {
    if (!selectedProvinceId) return [];
    return citiesData
      .filter((c) => c.province_id === selectedProvinceId)
      .map((c) => ({ value: c.name, label: c.name }));
  }, [selectedProvinceId]);

  const handleProvinceChange = (selected) => {
    setSendData({ ...sendData, province: selected.value, city: "" });
    setSelectedProvinceId(selected.id || null);
  };

  const handleCityChange = (selected) => {
    setSendData({ ...sendData, city: selected.value });
  };

  // ==================== آپشن‌های ساعت ====================
  const timeOptions = useMemo(() => {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const h = hour.toString().padStart(2, "0");
        const m = minute.toString().padStart(2, "0");
        const timeValue = `${h}:${m}`;
        const timeLabel = `${h}:${m}`;
        options.push({ value: timeValue, label: timeLabel });
      }
    }
    return options;
  }, []);

  // ==================== هندلرها ====================
  const handleCustomerChange = (selectedValue) => {
    const moshtari = moshtariOptions.find((c) => c.value === selectedValue);
    if (moshtari) {
      setSendData((prev) => {
        const isSameCustomer = prev.id_moshtari === selectedValue;
        return {
          ...prev,
          id_moshtari: selectedValue,
          name_moshtari: moshtari.label,
          state: moshtari.state,
          city: moshtari.city,
          address: moshtari.address,
          mobile_moshtari: moshtari.mobile,
          percent_profit: isSameCustomer
            ? prev.percent_profit
            : moshtari.percent_profit || 0,
        };
      });
    }
  };

  const handleChange = (name, value) => {
    if (name === "percent_profit" && Number(value) > 100) return;

    setSendData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="customer__information">
      <div className="form__grid">
        <DynaDatePicker
          label="تاریخ ثبت"
          name="date_sabt"
          className="solid-dyna-input"
          value={sendData.date_sabt}
          setDataFromComponent={(data) =>
            handleChange("date_sabt", data.date_sabt)
          }
        />

        <DynaSelectBox
          label="ساعت ثبت"
          name="time_sabt"
          options={timeOptions}
          hasFilter={false}
          className="solid-dyna-input"
          value={sendData.time_sabt}
          onChange={(data) => handleChange("time_sabt", data?.value)}
        />

        <DynaDatePicker
          label="تاریخ آماده سازی"
          name="date_amade"
          className="solid-dyna-input"
          value={sendData.date_amade}
          setDataFromComponent={(data) =>
            handleChange("date_amade", data.date_amade)
          }
        />

        <DynaSelectBox
          label="ساعت آماده سازی"
          name="time_amade"
          options={timeOptions}
          hasFilter={false}
          className="solid-dyna-input"
          value={sendData.time_amade}
          onChange={(data) => handleChange("time_amade", data?.value)}
        />

        <DynaDatePicker
          label="تاریخ تحویل"
          name="date_tahvil"
          className="solid-dyna-input"
          value={sendData.date_tahvil}
          setDataFromComponent={(data) =>
            handleChange("date_tahvil", data.date_tahvil)
          }
        />

        <DynaSelectBox
          label="ساعت تحویل"
          name="time_tahvil"
          options={timeOptions}
          hasFilter={false}
          className="solid-dyna-input"
          value={sendData.time_tahvil}
          onChange={(data) => handleChange("time_tahvil", data?.value)}
        />

        {isEditMode && (
          <DynaSelectBox
            options={statusOptions}
            hasFilter={false}
            label="وضعیت"
            className="solid-dyna-input"
            value={String(sendData.havale_status)}
            onChange={(data) =>
              setSendData({ ...sendData, havale_status: data?.value })
            }
            openDirection="up"
          />
        )}

        <DynaSelectBox
          options={moshtariOptions}
          hasFilter={false}
          label="انتخاب مشتری"
          className="solid-dyna-input"
          value={sendData.id_moshtari}
          onChange={(data) => handleCustomerChange(data.value)}
        />

        <DynaInput
          label="حاشیه سود (درصد)"
          name="percent_profit"
          className="solid-dyna-input"
          placeholder="حاشیه سود را وارد کنید"
          value={sendData.percent_profit ?? 0}
          type="text"
          setDataFromComponent={(data) =>
            handleChange("percent_profit", data.percent_profit)
          }
          hasComma={true}
          disabled={isEditMode || !sendData.id_moshtari}
        />

        <DynaSelectBox
          label={"استان *"}
          name={"province"}
          className={"solid-dyna-input"}
          options={provinceOptions}
          value={sendData?.province}
          hasFilter={true}
          onChange={handleProvinceChange}
        />

        <DynaSelectBox
          label={"شهر *"}
          name={"city"}
          className={"solid-dyna-input"}
          options={cityOptions}
          value={sendData?.city}
          hasFilter={true}
          onChange={handleCityChange}
          disabled={!selectedProvinceId}
        />

        <DynaInput
          label="شماره تماس"
          name="mobile_moshtari"
          className="solid-dyna-input"
          value={sendData.mobile_moshtari}
          type="text"
          setDataFromComponent={(data) =>
            handleChange("mobile_moshtari", data.mobile_moshtari)
          }
          disabled={true}
        />

        <div style={{ gridColumn: "1/-1" }}>
          <DynaInput
            label="آدرس"
            name="address"
            className="solid-dyna-input"
            value={sendData.address}
            type="text"
            setDataFromComponent={(data) =>
              handleChange("address", data.address)
            }
            disabled={true}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomerInformation;
